import { useTranslation } from "react-i18next";

/** Inline bilingual helper — returns Arabic when the current language is Arabic, English otherwise. */
export function useT() {
  const { i18n } = useTranslation();
  const ar = (i18n.language || "en").startsWith("ar");
  return (en: string, arStr: string) => (ar ? arStr : en);
}
